import { Injectable, inject } from '@angular/core';
import { Observable, finalize, map, shareReplay, throwError, timeout } from 'rxjs';
import { SessionStore } from '../state/session.store';
import { AuthService } from './auth.service';

const REFRESH_TIMEOUT_MS = 15_000;

@Injectable({ providedIn: 'root' })
export class TokenRefreshCoordinator {
  private readonly authService = inject(AuthService);
  private readonly session = inject(SessionStore);

  private inFlight$: Observable<void> | null = null;

  refresh(): Observable<void> {
    if (this.inFlight$) {
      return this.inFlight$;
    }

    const refreshToken = this.session.tokenPayload()?.refresh_token;
    if (!refreshToken) {
      return throwError(() => new Error('No refresh token available.'));
    }

    this.inFlight$ = this.authService.refreshAccessToken(refreshToken).pipe(
      timeout(REFRESH_TIMEOUT_MS),
      map(() => undefined),
      finalize(() => {
        this.inFlight$ = null;
      }),
      shareReplay({ bufferSize: 1, refCount: false }),
    );

    return this.inFlight$;
  }
}
